const PhaseProps = {
   'Queued': { bg: 'light', text: 'dark', border: 'none' },
  default: { bg: 'success-subtle', text: 'success', border: 'none' },
  'In Progress': { bg: 'warning-subtle', text: 'warning', border: 'none' },
};

export default PhaseProps;